<script setup lang="ts">
import type { Badge } from '../status/status';
defineProps<{ badge: Badge }>();
</script>

<template>
  <span class="badge" :class="`tone-${badge.tone}`" :title="badge.title">
    <span class="sym" aria-hidden="true">{{ badge.symbol }}</span>
    <span>{{ badge.label }}</span>
    <span class="sr-only">({{ badge.title }})</span>
  </span>
</template>
